import useId from '../utils/useId';
import * as React from 'react';
export const geminiSvg = React.forwardRef(function geminiSvgInner(props, ref) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: `url(#bi_gemini__a_${id_0})`,
      d: 'M15.975 3C15.555 9.974 9.974 15.554 3 15.975v.05c6.974.42 12.554 6.001 12.975 12.975h.05c.42-6.974 6.001-12.554 12.975-12.975v-.05C22.026 15.555 16.446 9.974 16.025 3z',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_gemini__a_${id_0}`,
          x1: 12.748,
          x2: 22.575,
          y1: 19.762,
          y2: 9.593,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#217bfe',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.14,
          stopColor: '#1485fc',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.27,
          stopColor: '#078efb',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.52,
          stopColor: '#548ffd',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.78,
          stopColor: '#a190ff',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.89,
          stopColor: '#af94fe',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#bd99fe',
        }),
      ),
    ),
  );
});
geminiSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '32',
  height: '32',
  fill: 'none',
  viewBox: '0 0 32 32',
};
export var gemini = {
  category: 'brand',
  colorable: false,
  name: 'gemini',
  svg: geminiSvg,
};
